module.exports = "::ng-deep .mat-select-panel .mat-option {\n  white-space: normal;\n  overflow: visible;\n  text-overflow: ellipsis;\n  display: block;\n  line-height: 1;\n  height: auto;\n  padding: 8px 16px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/icb/t2c/data/data.component.scss
// module id = 898
// module chunks = 10